'use strict';

(function () {
    'use strict';

    angular.module('customerCommunications', ['ui.router', 'common']);
})();